<template>
  <q-btn
    data-test-id="draft-order-cart-header-icon"
    flat
    :dense="$q.screen.lt.sm"
    round
    icon="fal fa-cart-shopping"
    size="12px"
    @click="$emit('check-out')"
  >
    <q-badge
      :label="$order.draftOrderItemsCartCount"
      color="red"
      floating
    />
  </q-btn>
</template>

<script>
export default {
  name: 'CartButton',
  emits: ['check-out']
}
</script>
